<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
        <g opacity="0.4">
            <path d="M11 1L6 5.40464L1 1" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                stroke-linejoin="round" />
        </g>
    </svg>
</template>
